<i18n>
{
  "fr": {
    "form-title": "Formulaire d'annonce pour le téléversement de données sur les eaux souterraines",
    "companyname-label": "Nom de l'entreprise",
    "address-label": "Adresse",
    "zip-label": "NPA",
    "city-label": "Ville",
    "firstname-label": "Prénom",
    "lastname-label": "Nom",
    "phone-label": "Numéro de téléphone",
    "email-label": "Adresse email",
    "projectname-label": "Nom du projet",
    "no-object-label": "N° objet",
    "description-label": "Description du projet",
    "projectgoal-label": "But du projet",
    "begin-label": "Début des travaux",
    "end-label": "Fin des travaux",
    "projectstatus-label": "Statut du projet",
    "comment-label": "Commentaires",
    "project-manager-title": "Auteur du dépôt",
    "client-title": "Maître d'ouvrage",
    "project-title": "Projet",
    "data-title": "Données",
    "geodata-title": "Emprise de la zone d'étude (CH1903+ / LV95)",
    "observation-description-title": "Points d'observation (informations descriptives)",
    "coord-label": "Coordonnées / altitude",
    "schema-label": "Schéma / plan de construction",
    "quant-data-title": "Données quantitatives",
    "qual-data-title": "Données qualitatives",
    "report-title": "Documents",
    "level-title": "Niveaux d'eau",
    "manual-data-label": "Mesures manuelles",
    "auto-data-label": "Mesures automatiques",
    "interpreted-data-label": "Mesures interprétées",
    "geodata-label": "Géodonnées",
    "sourceflow-title": "Débits",
    "drainagerate-title": "Débits d'exhaure",
    "in-situ-measure-title": "Mesures in-situ",
    "sample-title": "Echantillonnage",
    "report-label": "Rapport(s)",
    "appendice-label": "Annexe(s)",
    "map-label": "Plans / cartes",
    "profil-label": "Profils / sections",
    "submit-create-label": "Envoyer la demande",
    "submit-update-label": "Modifier la demande",
    "select-pleaseChoose": "Choisir...",
    "projectGoal-constructionAvantProjet": "Construction - Phase d’étude (avant-projet/projet général)",
    "projectGoal-constructionAutorisation": "Construction - Phase d’étude (projet définitif/MEP/autorisation)",
    "projectStatus-progress": "En cours",
    "projectStatus-done": "Terminé",
    "next-label": "Suivant",
    "previous-label": "Précédent",
    "required-field": "Ce champs est requis",
    "must-have-one-polygon-field": "Vous devez déssiner au moins un polygone",
    "error-in-step-label": "Des champs ne sont pas rempli correctement",
    "other-label": "Autres",
    "logs": "Journal",
    "change-form-status-label": "Changer le statut",
    "sampling-point-label": "Points de prélèvements",
    "sample-protocoles-label": "Protocoles d'échantillonnage",
    "chemical-analysis-label": "Analyses chimiques",
    "diagraphies-data-label": "Diagraphies",
    "pictures-label": "Photos",
    "piezo-label": "Piézomètres",
    "well-label": "Puits",
    "sources-label": "Sources",
    "welcome-step-title": "Information",
    "welcome-title": "Bienvenue",
    "greetings": "Madame, Monsieur",
    "welcome-description": "Les demandes pour la transmission des données d’observation sur les eaux souterraines sont à envoyer à l’adresse : <a href='mailto:SEN-STRATES@admin.vs.ch'>SEN-STRATES@admin.vs.ch</a>. Les modèles de fichiers pour la transmission des données quantitatives et qualitatives sont fournis sur <a href='https://www.vs.ch/fr/web/sen/systeme-information-eaux-souterraines-strates-vs'>la page web dédiée du Service de l’Environnement (SEN)</a>.",
    "welcome-description-2": "En cas de problème et/ou pour toute question, prière d’adresser un message à : <a href='mailto:SEN-STRATES@admin.vs.ch'>SEN-STRATES@admin.vs.ch</a>",
    "welcome-description-3": "Avec nos remerciements",
    "thankyou-step-title": "Fin",
    "thankyou-title": "Merci !",
    "thankyou-description": "Merci d'avoir complété le formulaire. Un accusé de réception vous a été adressé par mail dans lequel figurent les références de la présente demande. Avec nos remerciements.",
    "update-success": "Modifications enregistrées",
    "plotting-test-label": "Essai de traçage",
    "format-data-title": "Format de données",
    "csv-label": "XLS / CSV",
    "plain-text-label": "Texte",
    "form-follow": "Suivi",
    "form-detail": "Formulaire",
    "status-undefined": "Non défini",
    "status-waiting": "En attente de téléversement",
    "status-cancel": "Annulé",
    "status-running": "En cours",
    "status-done": "Terminé",
    "status-undefined": "Non défini",
    "status-waiting": "En attente de téléversement",
    "status-cancel": "Annulé",
    "status-running": "En cours",
    "status-done": "Terminé",
    "publicId-label": "N° de référence",
    "createDate-label": "Date de création",
    "lastUpdateDate-label": "Dernière modification"
  },
  "de": {
    "form-title": "Meldeformular zum Datenupload von Grundwasserdaten",
    "companyname-label": "Firma",
    "address-label": "Adresse",
    "zip-label": "PLZ",
    "city-label": "Stadt",
    "firstname-label": "Vorname",
    "lastname-label": "Name",
    "phone-label": "Telefonnummer",
    "email-label": "E-Mail",
    "projectname-label": "Name des Projekts",
    "no-object-label": "Objekt Nr",
    "description-label": "Beschreibung des Projekts",
    "projectgoal-label": "Ziel des Projekts",
    "begin-label": "Anfang der Baudegleitung",
    "end-label": "Ende des Baudegleitung",
    "projectstatus-label": "Projektstatus",
    "comment-label": "Bemerkungen",
    "project-manager-title": "Gesuchsteller",
    "client-title": "Bauherr",
    "project-title": "Projekt",
    "data-title": "Daten",
    "geodata-title": "Raum des untersuchten (CH1903+ / LV95)",
    "observation-description-title": "Überwachungsstellen (Beschreibende informationen)",
    "coord-label": "Koordinaten / Höhe",
    "schema-label": "Schéma / Bauplan",
    "quant-data-title": "Quantitative Daten",
    "qual-data-title": "Qualitative Daten",
    "report-title": "Dokuments",
    "level-title": "Wasserspiegel",
    "manual-data-label": "Manuelle Messungen",
    "auto-data-label": "Automatische Messungen",
    "interpreted-data-label": "Interpretierte Messungen",
    "geodata-label": "Geodaten",
    "sourceflow-title": "Fluss",
    "drainagerate-title": "Schüttung",
    "in-situ-measure-title": "In-situ Messungen",
    "sample-title": "Sampling",
    "report-label": "Bericht(e)",
    "appendice-label": "Beilage(n)",
    "map-label": "Pläne / Karte",
    "profil-label": "Profil / Schnitt",
    "submit-create-label": "Anfrage versenden",
    "submit-update-label": "Anfrage anpassen",
    "select-pleaseChoose": "Wählen...",
    "projectGoal-constructionAvantProjet": "Bau - Projektphase (Vorprojekt / general Projekt)",
    "projectGoal-constructionAutorisation": "Bau - Projektphase (definitives Projekt/Öffentliche Auflage /Baubewilligung)",
    "projectStatus-progress": "Im Gang",
    "projectStatus-done": "Fertig",
    "next-label": "Vorherige",
    "previous-label": "Nächste",
    "required-field": "Dieses Feld wird benötigt",
    "must-have-one-polygon-field": "Sie müssen mindestens ein Polygon zeichnen.",
    "error-in-step-label": "Felder sind nicht korrekt ausgefüllt.",
    "other-label": "Anderes",
    "logs": "Veranstaltung",
    "change-form-status-label": "Status ändern",
    "sampling-point-label": "Probenahmepunkte",
    "sample-protocoles-label": "Protocoles d'échantillonnage",
    "chemical-analysis-label": "Chemische Analysen",
    "diagraphies-data-label": "Logs",
    "pictures-label": "Bilder",
    "piezo-label": "Piézometer",
    "well-label": "Schacht",
    "sources-label": "Quellen",
    "welcome-step-title": "Informationen",
    "welcome-title": "Willkommen",
    "greetings": "Sehr geehrte Frau, sehr geehrter Herr",
    "welcome-description": "Les demandes pour la transmission des données d’observation sur les eaux souterraines sont à envoyer à l’adresse : <a href='mailto:SEN-STRATES@admin.vs.ch'>SEN-STRATES@admin.vs.ch</a>. Les modèles de fichiers pour la transmission des données quantitatives et qualitatives sont fournis sur <a href='https://www.vs.ch/fr/web/sen/systeme-information-eaux-souterraines-strates-vs'>la page web dédiée du Service de l’Environnement (SEN)</a>.",
    "welcome-description-2": "En cas de problème et/ou pour toute question, prière d’adresser un message à : <a href='mailto:SEN-STRATES@admin.vs.ch'>SEN-STRATES@admin.vs.ch</a>",
    "welcome-description-3": "Besten Dank",
    "thankyou-step-title": "Ende",
    "thankyou-title": "Danke !",
    "thankyou-description": "Vielen Dank für das Ausfüllen des Formulars. Wir haben Ihnen eine Empfangsbestätigung mit den Referenzen dieser Anfrage per E-Mail gesendet. Besten Dank.",
    "format-data-title": "Datenformat",
    "form-follow": "Follow-up",
    "form-detail": "Formular"
  }
}
</i18n>

<template>
  <div id="collect-data-gw" class="geo-forms">

    <Header :title="$t('form-title')" />

    <md-content class="md-layout md-elevation-3 main-container">

      <div v-if="!isNew" class="md-layout-item md-size-25 md-medium-size-35 md-small-size-100">
        <h2>{{ $t('logs') }}</h2>

        <LogForm
          v-if="!isReadOnly"
          v-on:submit="onNewLogSubmit"
          :isDisabled="form.status === 'undefined'"
        />
        <md-divider></md-divider>
        <LogCard v-for="(log, index) in form.logs.logs" :log="log" :key="index" />

      </div>

      <div :class="isNew ? 'md-layout-item md-size-100' : 'md-layout-item md-size-75 md-small-size-100 md-medium-size-65'">
        <md-tabs v-if="!isNew" class="form-tabs" md-sync-route>
          <md-tab id="tab-follow" :md-label="$t('form-follow')" :to="`/form/collect-data-gw/${form.publicId}/follow`"></md-tab>
          <md-tab id="tab-detail" :md-label="$t('form-detail')" :to="`/form/collect-data-gw/${form.publicId}`"></md-tab>
        </md-tabs>

        <md-steppers :class="isNew ? 'md-layout-item md-size-100 form-steps' : 'form-steps'" md-vertical :md-active-step="activeStep" :md-linear="isNew">
          <md-step
            v-if="isNew" id="welcome"
            :md-label="$t('welcome-step-title')"
            :md-done.sync="stepState.welcome.isActive"
            v-on:click="activeStep = 'welcome'"
            :md-editable="false"
          >
            <h2>{{ $t('welcome-title') }}</h2>

            <p>{{ $t('greetings') }}</p>
            <p v-html="$t('welcome-description')"></p>
            <p v-html="$t('welcome-description-2')"></p>
            <p v-html="$t('welcome-description-3')"></p>

            <!-- <div class="navigation-step-panel">
              <md-button class="md-raised md-primary" @click="goToStep1">{{ $t('next-label') }}</md-button>
            </div> -->
          </md-step>

          <md-step
            v-if="!isNew"
            id="projectOwner"
            :md-label="$t('project-manager-title')"
            :md-error="stepState.projectOwner.hasError"
            :md-done.sync="stepState.projectOwner.isActive"
            v-on:click="activeStep = 'projectOwner'"
            :md-editable="!isFormEnd"
          >

            <ContactForm
              :contact="form.projectOwner"
              :contacts="contacts"
              v-on:change="onProjectOwnerChange"
              ref="projectOwnerForm"
              :disabled="isReadOnly"
              :show="activeStep === 'projectOwner'"
            />

            <div v-if="isNew" class="navigation-step-panel">
              <md-button class="md-raised md-primary" @click="goToStep2">{{ $t('next-label') }}</md-button>
            </div>

          </md-step>

          <md-step
            v-if="!isNew"
            id="projectSupervisor"
            :md-label="$t('client-title')"
            :md-error="stepState.projectSupervisor.hasError"
            :md-done.sync="stepState.projectSupervisor.isActive"
            v-on:click="activeStep = 'projectSupervisor'"
            :md-editable="!isFormEnd"
          >

            <ContactForm
              :contact="form.projectSupervisor"
              :contacts="contacts"
              v-on:change="onProjectSupervisorChange"
              ref="projectSupervisorForm"
              :disabled="isReadOnly"
              :validations="projectSupervisorValidations"
              :show="activeStep === 'projectSupervisor'"
            />

            <div v-if="isNew" class="navigation-step-panel">
              <md-button class="md-primary" @click="goToStep1">{{ $t('previous-label') }}</md-button>
              <md-button class="md-raised md-primary" @click="goToStep3">{{ $t('next-label') }}</md-button>
            </div>

          </md-step>

          <md-step
            v-if="!isNew"
            id="project"
            :md-label="$t('project-title')"
            :md-error="stepState.project.hasError"
            :md-done.sync="stepState.project.isActive"
            v-on:click="activeStep = 'project'"
            :md-editable="!isFormEnd"
          >

            <div class="group-field">
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-50 md-small-size-100">
                  <ProjectForm
                    :project="form.project"
                    :projects="projects"
                    v-on:change="onProjectChange"
                    ref="projectForm"
                    :disabled="isReadOnly"
                    :show="activeStep === 'project'"
                  />
                  <md-field :class="getValidationClass('projectData','noObject')">
                    <label>{{ $t('no-object-label') }}</label>
                    <md-input v-model="form.projectData.noObject" required :disabled="isReadOnly"></md-input>
                    <span class="md-error" v-if="!$v.form.projectData.noObject.required">{{ $t('required-field') }}</span>
                  </md-field>
                  <md-field>
                    <label>{{ $t('description-label') }}</label>
                    <md-textarea v-model="form.projectData.description" md-autogrow :disabled="isReadOnly"></md-textarea>
                  </md-field>
                </div>
                <div class="md-layout-item md-medium-size-50 md-small-size-100">
                  <md-field :class="getValidationClass('projectData','projectGoal')">
                    <label>{{ $t('projectgoal-label') }}</label>
                    <md-input v-model="form.projectData.projectGoal" :disabled="isReadOnly"></md-input>
                  </md-field>
                  <md-datepicker v-model="form.projectData.beginDate" md-immediately :class="getValidationClass('projectData','beginDate')" :disabled="isReadOnly">
                    <label>{{ $t('begin-label') }} *</label>
                    <span class="md-error" v-if="!$v.form.projectData.beginDate.required">{{ $t('required-field') }}</span>
                  </md-datepicker>
                  <md-datepicker v-model="form.projectData.endDate" :md-disabled-dates="disableEndDate" :disabled="isReadOnly">
                    <label>{{ $t('end-label') }}</label>
                  </md-datepicker>
                  <md-field :class="getValidationClass('projectData','projectStatus')">
                    <label>{{ $t('projectstatus-label') }} {{form.projectData.projectStatus}}</label>
                    <md-select v-model="form.projectData.projectStatus" required :disabled="isReadOnly">
                      <md-option value="">{{ $t('select-pleaseChoose') }}</md-option>
                      <md-option value="projectStatus_progress">{{ $t('projectStatus-progress') }}</md-option>
                      <md-option value="projectStatus_done">{{ $t('projectStatus-done') }}</md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.form.projectData.projectStatus.required">{{ $t('required-field') }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout">
                <md-field class="md-layout-item">
                  <label>{{ $t('comment-label') }}</label>
                  <md-textarea v-model="form.projectData.comments" md-autogrow :disabled="isReadOnly"></md-textarea>
                </md-field>
              </div>
            </div>

            <div v-if="isNew" class="navigation-step-panel">
              <md-button class="md-primary" @click="goToStep2">{{ $t('previous-label') }}</md-button>
              <md-button class="md-raised md-primary" @click="goToStep4">{{ $t('next-label') }}</md-button>
            </div>

          </md-step>

          <md-step
            v-if="!isNew"
            id="data"
            :md-label="$t('data-title')"
            :md-error="stepState.data.hasError"
            :md-done.sync="stepState.data.isActive"
            v-on:click="activeStep = 'data'"
            :md-editable="!isFormEnd"
          >

            <div class="group-field narrow">

              <div class="data-form section">

                <h3>{{ $t('geodata-title') }}</h3>
                <md-field :class="getValidationClass('geom')">
                  <Map
                    ref="map"
                    class="map"
                    :drawGeom="form.geom"
                    v-on:drawChange="onGeomChange"
                    :disabled="isReadOnly"
                    :show="activeStep === 'data'"
                  />
                  <span class="md-error" v-if="!$v.form.geom.mustHaveOnePolygon">{{ $t('must-have-one-polygon-field') }}</span>
                </md-field>
              </div>

              <md-divider></md-divider>

              <div class="data-form section">

                <h3>{{ $t('observation-description-title') }}</h3>
                <div class="md-layout">
                  <h4 class="md-layout-item md-medium-size-30 md-size-20"></h4>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.observationPoint.isPiezo"     >{{ $t('piezo-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.observationPoint.isWell"    >{{ $t('well-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.observationPoint.isSources"     >{{ $t('sources-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.observationPoint.isOther"    >{{ $t('other-label') }}</md-checkbox>
                </div>
                <div class="md-layout">
                  <h4 class="md-layout-item md-medium-size-30 md-size-20">{{ $t('format-data-title') }}</h4>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.observationPoint.format.isGeodata"   >{{ $t('geodata-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.observationPoint.format.isCsv"            >{{ $t('csv-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.observationPoint.format.isText"            >{{ $t('plain-text-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.observationPoint.format.isOther"            >{{ $t('other-label') }}</md-checkbox>
                </div>

              </div>

              <md-divider></md-divider>

              <div class="data-form section">

                <h3>{{ $t('quant-data-title') }}</h3>
                <div class="md-layout">
                  <h4 class="md-layout-item md-medium-size-30 md-size-20">{{ $t('level-title') }}</h4>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.gwLevel.isManual"             >{{ $t('manual-data-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.gwLevel.isAuto"               >{{ $t('auto-data-label') }}</md-checkbox>
                </div>
                <div class="md-layout">
                  <h4 class="md-layout-item md-medium-size-30 md-size-20">{{ $t('sourceflow-title') }}</h4>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.sourceFlow.isManual"          >{{ $t('manual-data-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.sourceFlow.isAuto"            >{{ $t('auto-data-label') }}</md-checkbox>
                </div>
                <div class="md-layout">
                  <h4 class="md-layout-item md-medium-size-30 md-size-20">{{ $t('format-data-title') }}</h4>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.quantData.format.isGeodata"   >{{ $t('geodata-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.quantData.format.isCsv"            >{{ $t('csv-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.quantData.format.isText"            >{{ $t('plain-text-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.quantData.format.isOther"            >{{ $t('other-label') }}</md-checkbox>
                </div>

              </div>

              <md-divider></md-divider>

              <div class="data-form section">

                <h3>{{ $t('qual-data-title') }}</h3>
                <div class="md-layout">
                  <h4 class="md-layout-item md-medium-size-30 md-size-20">{{ $t('in-situ-measure-title') }}</h4>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.inSituMeasure.isManual"       >{{ $t('manual-data-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.inSituMeasure.isAuto"         >{{ $t('auto-data-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.inSituMeasure.isDiagraphies"  >{{ $t('diagraphies-data-label') }}</md-checkbox>
                </div>
                <div class="md-layout">
                  <h4 class="md-layout-item md-medium-size-30 md-size-20">{{ $t('sample-title') }}</h4>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.sample.isSamplingPoint"       >{{ $t('sampling-point-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.sample.isProtocol"            >{{ $t('sample-protocoles-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.sample.isChemical"            >{{ $t('chemical-analysis-label') }}</md-checkbox>
                </div>
                <div class="md-layout">
                  <h4 class="md-layout-item md-medium-size-30 md-size-20">{{ $t('format-data-title') }}</h4>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.qualData.format.isGeodata"   >{{ $t('geodata-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.qualData.format.isCsv"            >{{ $t('csv-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.qualData.format.isText"            >{{ $t('plain-text-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.qualData.format.isOther"            >{{ $t('other-label') }}</md-checkbox>
                </div>

              </div>

              <md-divider></md-divider>

              <div class="data-form section">

                <div class="md-layout">
                  <h3 class="md-layout-item md-size-50">
                    {{ $t('plotting-test-label') }}
                  </h3>
                </div>
                <div class="md-layout">
                  <h4 class="md-layout-item md-medium-size-30 md-size-20">{{ $t('format-data-title') }}</h4>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.plottingTest.format.isGeodata"   >{{ $t('geodata-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.plottingTest.format.isCsv"            >{{ $t('csv-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.plottingTest.format.isText"            >{{ $t('plain-text-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-20" v-model="form.formData.plottingTest.format.isOther"            >{{ $t('other-label') }}</md-checkbox>
                </div>

              </div>

              <md-divider></md-divider>

              <div class="data-form section">

                <h3>{{ $t('report-title') }}</h3>
                <div class="md-layout">
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15"  v-model="form.formData.report.isReport"             >{{ $t('report-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15"  v-model="form.formData.report.isAppendice"          >{{ $t('appendice-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15"  v-model="form.formData.report.isMap"                >{{ $t('map-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15"  v-model="form.formData.report.isProfil"             >{{ $t('profil-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15"  v-model="form.formData.report.isPictures"             >{{ $t('pictures-label') }}</md-checkbox>
                  <md-checkbox :disabled="isReadOnly" class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15"  v-model="form.formData.report.isOther"              >{{ $t('other-label') }}</md-checkbox>
                </div>

                <md-field class="md-layout-item">
                  <label>{{ $t('comment-label') }}</label>
                  <md-textarea v-model="form.formData.comments" md-autogrow :disabled="isReadOnly"></md-textarea>
                </md-field>

              </div>

            </div>

            <div v-if="isNew" class="navigation-step-panel">
              <md-button class="md-primary" @click="goToStep3">{{ $t('previous-label') }}</md-button>
              <md-button class="md-raised md-primary" v-on:click="submitForm">{{ submitLabel }}</md-button>
            </div>

          </md-step>

        </md-steppers>

      </div>

      <div v-if="!isReadOnly && !isNew" class="option-panel fixed md-layout md-size-100">
        <div class="align-left md-layout-item md-size-75">
          <md-field class="info">
            <label>{{ $t('publicId-label') }}</label>
            <md-input v-bind:value="form.publicId" disabled></md-input>
          </md-field>
          <md-chip :class="`status-info ${form.status}`">{{ $t('status-' + form.status) }}</md-chip>
          <md-field class="info">
            <label>{{ $t('createDate-label') }}</label>
            <md-input v-bind:value="form.createDate" disabled></md-input>
          </md-field>
          <md-field class="info">
            <label>{{ $t('lastUpdateDate-label') }}</label>
            <md-input v-bind:value="form.lastUpdateDate" disabled></md-input>
          </md-field>
        </div>
        <div class="align-right md-layout-item md-size-25">
          <md-button class="md-raised md-primary" v-on:click="submitForm">{{ submitLabel }}</md-button>
        </div>
      </div>

    </md-content>

    <Snackbar ref="snackbar" />

  </div>
</template>

<script>

import 'ol/ol.css'
import { validationMixin } from 'vuelidate'

import {
  required
} from 'vuelidate/lib/validators'
import {
  mustHaveOnePolygon
} from '@/helpers/field-validators'

import FormCollectDataGW from '@/models/FormCollectDataGW/Form'
import Contact from '@/models/default/Contact'
import Project from '@/models/default/Project'

import AccessToken from '@/helpers/access-token'

import ContactForm from '@/components/contact-form'
import ProjectForm from '@/components/project-form'
import LogCard from '@/components/log-card'
import LogForm from '@/components/log-form'
import Header from '@/components/header'
import Map from '@/components/map'
import Snackbar from '@/components/snackbar'

export default {
  name: 'FormCollectDataGW',
  data () {
    let isNew = typeof this.$route.params.id === 'undefined'

    return {
      form: new FormCollectDataGW(),
      contacts: [],
      projects: [],
      isNew: isNew,
      isFormEnd: false,
      activeStep: isNew ? 'welcome' : 'data',
      stepState: {
        welcome: {
          isActive: false,
          hasError: null
        },
        projectOwner: {
          isActive: false,
          hasError: null
        },
        projectSupervisor: {
          isActive: false,
          hasError: null
        },
        project: {
          isActive: false,
          hasError: null
        },
        data: {
          isActive: false,
          hasError: null
        }
      },
      projectSupervisorValidations: {
        firstName: {

        },
        lastName: {

        }
      }
    }
  },
  components: {
    ContactForm,
    ProjectForm,
    LogCard,
    LogForm,
    Header,
    Map,
    Snackbar
  },
  mixins: [validationMixin],
  validations: {
    form: {
      geom: {
        mustHaveOnePolygon
      },
      projectData: {
        noObject: {
          required
        },
        beginDate: {
          required
        },
        projectStatus: {
          required
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadData().then(() => {
        if (this.isNew) return
        this.$refs.map.initMap({
          extent: this.form.extent
        })
      }).catch(this.handleError)
    })
  },
  computed: {
    submitLabel () {
      return this.isNew ? this.$t('submit-create-label') : this.$t('submit-update-label')
    },
    isReadOnly () {
      let accessToken = AccessToken.get()
      if (this.isNew) return false
      return accessToken === null || accessToken.hasReadOnlyrRights()
    }
  },
  methods: {
    getValidationClass (rootName, fieldName) {
      let field

      if (typeof fieldName === 'undefined') {
        field = this.$v.form[rootName]
      } else {
        field = this.$v.form[rootName][fieldName]
      }

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    onProjectOwnerChange (contact) {
      this.form.projectOwner = contact
    },
    onProjectSupervisorChange (contact) {
      this.form.projectSupervisor = contact
    },
    onProjectChange (project) {
      this.form.project = project
    },
    onGeomChange (geom) {
      this.form.geom = geom
    },
    disableEndDate (date) {
      return date < this.form.projectData.beginDate
    },
    loadData () {
      return new Promise((resolve, reject) => {
        let toFetch = []
        toFetch.push(Contact.list())
        toFetch.push(Project.list())
        if (typeof this.$route.params.id !== 'undefined') {
          toFetch.push(FormCollectDataGW.get(this.$route.params.id))
        }

        Promise.all(toFetch).then((data) => {
          this.contacts = data[0]
          this.projects = data[1]
          this.form = typeof data[2] !== 'undefined' ? data[2] : new FormCollectDataGW()
          this.form.projectData.beginDate = new Date(this.form.projectData.beginDate)
          resolve()
        }).catch(reject)
      })
    },
    isStep1Valid () {
      this.$refs.projectOwnerForm.$v.$touch()
      return !this.$refs.projectOwnerForm.$v.$invalid
    },
    isStep2Valid () {
      this.$refs.projectSupervisorForm.$v.$touch()
      return !this.$refs.projectSupervisorForm.$v.$invalid
    },
    isStep3Valid () {
      this.$refs.projectForm.$v.$touch()
      this.$v.form.projectData.$touch()
      return !this.$refs.projectForm.$v.$invalid && !this.$v.form.projectData.$invalid
    },
    isStep4Valid () {
      this.$v.form.geom.$touch()
      return !this.$v.form.geom.$invalid
    },
    goToStep1 () {
      this.stepState.welcome.isActive = true
      this.activeStep = 'projectOwner'
    },
    goToStep2 () {
      if (this.isStep1Valid()) {
        this.stepState.projectOwner.isActive = true
        this.activeStep = 'projectSupervisor'
      }
    },
    goToStep3 () {
      if (this.isStep2Valid()) {
        this.stepState.projectSupervisor.isActive = true
        this.activeStep = 'project'
      }
    },
    goToStep4 () {
      if (this.isStep3Valid()) {
        this.stepState.project.isActive = true
        this.activeStep = 'data'
        this.$refs.map.repaint()
      }
    },
    goToStep5 () {
      this.stepState.data.isActive = true
      this.stepState.data.hasError = false
      this.activeStep = 'thankyou'
      this.isFormEnd = true
    },
    submitForm () {
      // Tester toutes les étapes et la mettre en erreur si besoin
      let error = false

      if (!this.isStep1Valid()) {
        error = true
        this.stepState.projectOwner.hasError = this.$t('error-in-step-label')
      }
      if (!this.isStep2Valid()) {
        error = true
        this.stepState.projectSupervisor.hasError = this.$t('error-in-step-label')
      }
      if (!this.isStep3Valid()) {
        error = true
        this.stepState.project.hasError = this.$t('error-in-step-label')
      }
      if (!this.isStep4Valid()) {
        error = true
        this.stepState.data.hasError = this.$t('error-in-step-label')
      }

      if (!error) {
        this.form.formData.lang = this.$root.$i18n.locale
        this.form.save().then(() => {
          if (this.isNew) {
            this.goToStep5()
          } else {
            this.$refs.snackbar.show(this.$t('update-success'))
          }
        }).catch(this.handleError)
      }
    },
    onNewLogSubmit (log) {
      this.form.addLog(log).then(() => {
        this.$refs.snackbar.show(this.$t('update-success'))
      }).catch(this.handleError)
    },
    changeStatus (status) {
      this.form.changeStatus(status).then(() => {
        this.$refs.snackbar.show(this.$t('update-success'))
      }).catch(this.handleError)
    },
    handleError (e) {
      this.$refs.snackbar.showError(e)
    }
  }
}
</script>

<style lang="scss">

.flex-container {
  display: flex;
}

.group-field {
  padding: 20px;

  &.narrow {
    .md-layout-item {
      padding: 7px;
      margin: 5px;
    }
  }
}

.data-form.section {
  padding-top: 25px;
  padding-bottom: 35px;

  h3 {
    font-size: 1.5em;
    margin-top: 0px;
  }
}

.map {
  width: 100%;
  height:400px;
}

.md-layout-item {
  padding: 10px;
}

.md-menu-content-bottom-start.md-menu-content-small.md-menu-content.md-theme-default {
  @media(max-width: 960px) {
    left: 10px !important;
    max-width: calc(100% - 20px);
  }
  @media(min-width: 960px){
    max-width: 50%
  }
}

.navigation-step-panel {
  text-align: right;
}

.change-form-status-menu {
  margin-top: 6px;
}

.form-steps {
  @media(max-width: 600px) {
    padding: 0px !important;
  }
}

.form-tabs {
  margin-bottom: 12px;
}

@media(min-width: 1260px) {
  .md-layout-item.md-size-20 {
    min-width: 19% !important;
    max-width: 19% !important;
    flex: 0 1 19% !important;
  }
}

</style>
